<template>
  <div class="rail">
    <!-- QR Code (ação principal) -->
    <button
      type="button"
      class="rail-btn active"
      @click="go(routeScanName)"
    >
      <span class="rail-label">QR Code</span>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <rect x="3" y="3" width="6" height="6" rx="1" stroke="currentColor" stroke-width="1.5"/>
        <rect x="11" y="3" width="6" height="6" rx="1" stroke="currentColor" stroke-width="1.5"/>
        <rect x="3" y="11" width="6" height="6" rx="1" stroke="currentColor" stroke-width="1.5"/>
        <rect x="5" y="5" width="2" height="2" fill="currentColor" rx="0.5"/>
        <rect x="13" y="5" width="2" height="2" fill="currentColor" rx="0.5"/>
        <rect x="5" y="13" width="2" height="2" fill="currentColor" rx="0.5"/>
        <path d="M11 13h2v2h-2zM15 11v2h2M11 17h6" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/>
      </svg>
    </button>

    <!-- Reconhecimento facial — desabilitado (cinza) quando o evento não tem o recurso -->
    <button
      type="button"
      class="rail-btn"
      :disabled="!facialRecognitionEnabled"
      :title="facialRecognitionEnabled ? 'Reconhecimento facial' : 'Reconhecimento facial desativado nas configurações do evento'"
      @click="go(routeFacialName)"
    >
      <span class="rail-label">{{ facialRecognitionEnabled ? 'Facial' : 'Facial (desativado)' }}</span>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M3 7V5a2 2 0 012-2h2M13 3h2a2 2 0 012 2v2M3 13v2a2 2 0 002 2h2M13 17h2a2 2 0 002-2v-2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        <circle cx="7.5" cy="8.5" r="1" fill="currentColor"/>
        <circle cx="12.5" cy="8.5" r="1" fill="currentColor"/>
        <path d="M7.5 13c1 1.5 4 1.5 5 0" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/>
      </svg>
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { CHECK_IN_PAGE_SCAN, CHECK_IN_PAGE_FACIAL } from '@/modules/check-in/routes'

export default {
  name: 'index-footer',
  data: () => ({
    routeScanName: CHECK_IN_PAGE_SCAN,
    routeFacialName: CHECK_IN_PAGE_FACIAL
  }),
  computed: {
    // Reconhecimento facial só fica ativo se o evento tiver o recurso ligado
    // (/settings/rsvp → "Reconhecimento facial no último step" = SIM).
    ...mapGetters('event', ['facialRecognitionEnabled'])
  },
  created () {
    // Garante o setting carregado (idempotente — só busca se ainda vazio).
    this.$store.dispatch('event/LoadOnceSetting')
  },
  methods: {
    go (name) {
      this.$router.push({ name })
    }
  }
}
</script>

<style scoped>
.rail {
  position: fixed;
  right: 16px;
  bottom: 28px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 4px;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border-radius: 18px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  z-index: 1000;
}

.rail-btn {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  border: none;
  background: transparent;
  color: #7b8294;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
  position: relative;
}

.rail-btn:hover:not(:disabled) {
  background: rgba(37, 99, 235, 0.08);
  color: rgb(37, 99, 235);
}

.rail-btn.active {
  background: rgb(37, 99, 235);
  color: #fff;
  box-shadow: 0 4px 16px rgba(37, 99, 235, 0.3);
}

/* Desativado: cinza claro, sem clique */
.rail-btn:disabled {
  color: #d5d8e0;
  cursor: not-allowed;
  background: transparent;
  box-shadow: none;
}

.rail-label {
  position: absolute;
  right: 58px;
  top: 50%;
  transform: translateY(-50%) translateX(4px);
  padding: 6px 12px;
  background: rgba(26, 29, 38, 0.9);
  border-radius: 8px;
  font-size: 0.6875rem;
  font-weight: 700;
  color: #fff;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
}

.rail-btn:hover .rail-label {
  opacity: 1;
  transform: translateY(-50%) translateX(0);
}
</style>
